export default {
    INIT: "INIT",
    CLEAN_UP: "CLEAN_UP",
    RESET_SELECTED_ELEMENTS: "RESET_SELECTED_ELEMENTS",
};
